jQuery(document).ready(function() {

	//if(document.getElementById('projects') || document.getElementById('news') /*|| document.getElementById('team')  || document.getElementById('single')*/){

		//console.log('Start loading...');
		percentage = 0;
		total = jQuery('.grid').find('.grid-item:not(.header-title)').length;
		ratio=100/total;

		jQuery( 'body').css('overflow-y', 'hidden');
		jQuery( '.loading__container').css('visibility', 'visible');

		new Vivus('loader', {duration: 200, type: 'oneByOne', animTimingFunction: Vivus.EASE }, function (myVivus) {
			//myVivus.play(myVivus.getStatus() === 'end' ? -1 : 1);
			setTimeout(function() {
				if (myVivus.getStatus() === 'end') {
					myVivus.reset().play();
				}
			}, 500);
			//console.log('ok');
		});

		var $grid = jQuery('.grid').imagesLoaded({ background: '.grid-item:not(.header-title) .child' }, function() {
			$grid.isotope({
			  layoutMode: 'packery',
			  itemSelector: '.grid-item',
			  percentPosition: true,
			  stagger: 30,
			  transitionDuration: '0.8s',
			  visibleStyle: { transform: 'translateY(0)', opacity: 1 },
			  hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
			  sortBy: 'original-order',
			  /*getSortData: {
				   number: '[data-order] parseInt'
			  },*/
			})
		})
		.progress( function( instance, image ) {

	    	percentage += 1;
	    	percent = percentage*ratio;
	    	//console.log(percent.toFixed(0) + ' %')
	    	//myVivus.setFrameProgress(percent.toFixed(0));

	    })
		.always( function( instance ) {

				//console.log('Loading done. Wait...');

				setTimeout( function(){
				
					fadein();

				}, 3000);

				jQuery('.filters').on( 'click', 'a', function() {

					ScrollReveal().destroy();

				  jQuery('.filters').css("cursor", "progress");
				  jQuery('.filters a').css("pointer-events", "none");
				  jQuery('.filters a').attr('disabled',true);

				  var filterValue = jQuery(this).attr('data-filter');
				  jQuery( '.grid-item:not('+filterValue+')' ).css('width', '');
				  if('*' !== filterValue){
				  	/*jQuery( '.grid-item'+filterValue ).css('width', '50%!important');*/
					jQuery( '.grid-item'+filterValue+':eq(0)' ).css('width', '60%');
				  }
				  $grid.isotope({ 
				  	filter: '.header-title, '+filterValue,
				  	sortBy : 'original-order',
				  });
				  $grid.on( 'arrangeComplete', function( event, filteredItems ) {
					  //console.log( filteredItems.length );
					  jQuery('.filters').css("cursor", "default");
					  jQuery('.filters a').css("pointer-events", "inherit");
					  jQuery('.filters a').attr('disabled',false);
					});
				});

		 });

	/*} else {

		fadein();

	}*/

});

function fadein(){

	jQuery( '.loading__container').fadeOut('500',function() {
						jQuery( 'body').css('overflow-y', 'auto');
					});
			
					ScrollReveal().reveal('.logo', {
						delay: 500,
						duration: 500,
						opacity: 0,
						distance: '20px',
						origin: 'top',
						easing: 'ease-out'
					});
					ScrollReveal().reveal('.header .menu li', {
							delay: 0,
							duration: 500,
							interval: 250,
							opacity: 0,
							distance: '20px',
							origin: 'top',
							easing: 'ease-out'
					});
					ScrollReveal().reveal('.article-header, .single-header', {
							delay: 500,
							duration: 500,
							opacity: 0,
							distance: '20px',
							origin: 'top',
							easing: 'ease-out'
					});
					ScrollReveal().reveal('.page-title', {
							delay: 1000,
							duration: 500,
							opacity: 0,
							distance: '20px',
							origin: 'bottom',
							easing: 'ease-out'
					});
					ScrollReveal().reveal('section.entry-content', {
							delay: 1000,
							duration: 500,
							opacity: 0,
							distance: '20px',
							origin: 'bottom',
							easing: 'ease-out'
					});
					ScrollReveal().reveal('.filters li', {
							delay: 1000,
							duration: 500,
							interval: 250,
							opacity: 0,
							distance: '20px',
							origin: 'top',
							easing: 'ease-out'
					});

				    ScrollReveal().reveal('.grid-item:not(.header-title)', {
				    	delay: 1000,
				    	duration: 500,
						interval: 100,
						opacity: 0,
						distance: '100px',
						origin: 'bottom',
						easing: 'ease-out'
					});
					ScrollReveal().reveal('.footer', {
						delay: 1000,
						duration: 500,
						interval: 250,
						opacity: 0,
						distance: '20px',
						origin: 'bottom',
						easing: 'ease-out'
					});
}
